'use strict';

import './CardList.scss';

export default function CardList() {
  const cardTypes = ['americanexpress', 'visa', 'discover', 'mastercard'];

  return (
    <div className='card-list-container mt-3'>
      <p>Secure payments provided by</p>
      <div className='card-list'>
        {cardTypes.map(type => (
          <div key={type}>
            <img src={`/themes/custom/store/images/${type}.png`} alt={type} />
          </div>
        ))}
      </div>
    </div>
  );

}
